import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";
import { Field, Control, Button } from "rbx";

import Section from "../Section";

import { CREATE_DIRECTION_MUTATION } from "../../graphql/Directions/Directions.graphql";

import { ourToast as toast } from "../../utils";

import DirectionForm from "./DirectionForm";

class AddDirectionForm extends Component {
  state = {
    OriginLocationRecIdRef: this.props.id,
    DestinationLocationRecIdRef: this.props.id,
    LoadedMiles: "",
    LoadedTravelTime: "",
    EmptyMiles: "",
    EmptyTravelTime: "",
    LoadingTime: "",
    UnloadingTime: "",
    Directions: "",
    Priority: "1",
    SpecInstr: ""
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const {
      OriginLocationRecIdRef,
      DestinationLocationRecIdRef,
      LoadedMiles,
      LoadedTravelTime,
      EmptyMiles,
      EmptyTravelTime,
      LoadingTime,
      UnloadingTime,
      Directions,
      Priority,
      SpecInstr
    } = this.state;

    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={CREATE_DIRECTION_MUTATION}
        refetchQueries={["ALL_DIRECTIONS_QUERY"]}
        variables={{
          data: {
            CompanyId: "TRN",
            OriginLocationRecIdRef: parseInt(OriginLocationRecIdRef),
            DestinationLocationRecIdRef: parseInt(DestinationLocationRecIdRef),
            LoadedMiles: parseInt(LoadedMiles),
            LoadedTravelTime: parseInt(LoadedTravelTime),
            EmptyMiles: parseInt(EmptyMiles),
            EmptyTravelTime: parseInt(EmptyTravelTime),
            LoadingTime: parseInt(LoadingTime),
            UnloadingTime: parseInt(UnloadingTime),
            Directions,
            SpecInstr,
            Priority: parseInt(Priority)
          }
        }}
      >
        {(createDirection, { loading, error }) => (
          <form
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              try {
                await createDirection();
                toast.success("Direction created successfully.");
                onComplete();
              } catch (err) {
                toast.error("Error creating Direction.");
              }
            }}
          >
            <fieldset aria-busy={loading}>
              <Section title="Add Direction">
                <DirectionForm
                  inputs={{
                    OriginLocationRecIdRef,
                    DestinationLocationRecIdRef,
                    LoadedMiles,
                    LoadedTravelTime,
                    EmptyMiles,
                    EmptyTravelTime,
                    LoadingTime,
                    UnloadingTime,
                    Directions,
                    Priority,
                    SpecInstr
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Section>
            </fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

AddDirectionForm.propTypes = {
  onComplete: PropTypes.func,
  id: PropTypes.number
};

export default AddDirectionForm;
